import {
  shape,
  string,
  bool,
  number
} from 'prop-types';

export default shape({
  id: number.isRequired,
  title: string.isRequired,
  price: number,
  formatedPrice: string.isRequired,
  onetimePayment: bool.isRequired
});




// WEBPACK FOOTER //
// ./src/utils/shapes/BikeExtras.js